import { forwardRef } from 'react';
import styled from 'styled-components';

interface Props {
    alt?: string;
    className?: any;
    icon: string;
    onClick?: () => void;
    size?: number;
    title?: string;
}

function Icon({ icon, size = 24, ...rest }: Props, ref: any) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const svg = require(`!raw-loader!../files/icons/${icon}.svg`);
        return (
            <Wrapper
                ref={ref}
                {...rest}
                dangerouslySetInnerHTML={{ __html: svg }}
                size={size}
            />
        );
    } catch (error) {
        console.error(error);
        return <div ref={ref}></div>;
    }
}

export default forwardRef(Icon);

const Wrapper = styled.div<{ size?: number }>`
    display: flex;
    align-items: center;
    justify-content: center;


    svg {
        fill: 'currentColor';
        height: ${(props) => (props.size ? props.size + 'px' : 'unset')};
        width: ${(props) => (props.size ? props.size + 'px' : 'unset')};
    }
`